import styled from "styled-components";
import { Button } from "antd";
import { PageHeaderStyled } from "styles/common.styles";

// Back control shared by every page header that can navigate up a level.
export const BackButtonStyled = styled(Button).attrs({ type: "text" })`
  && {
    color: ${(p) => p.theme?.colors?.dark ?? "#2B3034"};
    padding: 4px 6px;
    height: auto;
    border-radius: 4px;
  }
  &&:hover {
    background: ${(p) => p.theme?.colors?.secondary ?? "#DDEAEA"};
  }
`;

// Opt-in 3-column layout (title block | centre slot | actions) with fixed
// gutters, for headers whose centre slot needs breathing room (the Employee
// Skills Bridger score gauge). The default flex layout is used everywhere else.
export const PageHeaderGridStyled = styled(PageHeaderStyled)`
  display: grid;
  grid-template-columns: 3fr minmax(100px, 1fr) 2fr;
  align-items: center;
  column-gap: 80px;
  row-gap: 16px;
  > div { flex: unset; }
  > div:first-child { flex: unset; }
  > div:last-child { flex: unset; }
`;
